module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Martigny-b8e760ed1e3f3978d0ed69bc6252f34a.svg";